import React, { useState } from 'react';
import './Blog.css'; // Using Blog.css for modal styling

const BlogModal = ({ blog, onClose }) => {
  const [enlargedImage, setEnlargedImage] = useState(null); // To hold the enlarged image view

  // Handle opening the image in enlarged view
  const handleImageClick = (img) => {
    setEnlargedImage(img); // Set the clicked image as the enlarged image
  };

  // Handle closing the enlarged image view
  const handleCloseEnlargedImage = () => {
    setEnlargedImage(null); // Close the enlarged image view
  };

  if (!blog) return null; // Safeguard against undefined blog data

  const {
    title = 'No Title',
    description = 'No description available.',
    mainImage = '/default-image.png', // Default image fallback
    additionalImages = [],
    tags = [] // Added tags
  } = blog;

  return (
    <div className="modal-overlay show" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close-btn" onClick={onClose}>
          &times;
        </button>

        {/* Blog Images */}
        <div className="modal-images">
          <img
            src={mainImage}
            alt={title}
            className="main-image"
            onClick={() => handleImageClick(mainImage)} // Open main image in enlarged view
          />

          {/* Display additional images */}
          {additionalImages.length > 0 && (
            <div className="additional-images">
              {additionalImages.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt={`Additional image ${index + 1}`}
                  onClick={() => handleImageClick(img)} // Open additional image in enlarged view
                />
              ))}
            </div>
          )}
        </div>

        {/* Blog Info Container (Title, Description, Tags) */}
        <div className="modal-info">
          {/* Blog Title */}
          <div className="modal-header">
            <h2>{title}</h2>
          </div>

          {/* Blog Description */}
          <div className="modal-description">
            {description.split("\n").map((line, index) => (
              <span key={index}>
                {line}
                <br />
              </span>
            ))}
          </div>

          {/* Blog Tags */}
          {tags.length > 0 && (
            <div className="modal-tags">
              <h3></h3>
              <ul>
                {tags.map((tag, index) => (
                  <li key={index}>{tag}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>

      {/* Enlarged Image View */}
      {enlargedImage && (
        <div className="enlarged-image-container">
          <div className="enlarged-image-content">
            <img src={enlargedImage} alt="Enlarged View" className="enlarged-image" />
            <button className="enlarged-image-close-btn" onClick={handleCloseEnlargedImage}>
              &times;
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default BlogModal;